import React from 'react';
import { EditorBaseStyle } from '@teetsh/app/src/components/Editor/styles/EditorBaseStyle';

import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import toggleCheckboxHTML from '@teetsh/app/src/components/Editor/plugins/insertTodo/toggleCheckboxHTML';
import clsx from 'clsx';

interface Props {
  text?: string;
  className?: string;
  onChange: (text: string) => void;
  print?: boolean;
}

export default function HtmlViewer(props: Props) {
  const { text, className, print } = props;

  return (
    <EditorBaseStyle
      className={clsx('html-view', print && 'print', className)}
      onClick={e => {
        const target = e.target as HTMLElement;
        if ((target?.tagName || '').toLowerCase() === 'a') {
          e.stopPropagation();
        }
        if (
          target.tagName === 'INPUT' &&
          (e.target as HTMLInputElement).type === 'checkbox'
        ) {
          e.stopPropagation();
          if (props.onChange) {
            props.onChange(
              toggleCheckboxHTML(
                text || '',
                target.id,
                (target as HTMLInputElement).checked,
              ),
            );
          }
        }
      }}
    >
      <div
        className="fr-view"
        dangerouslySetInnerHTML={{ __html: text ?? '' }}
      />
    </EditorBaseStyle>
  );
}
